import { useState } from "react";
import { Avatar, Box } from "@mui/material";
import { Person } from "@mui/icons-material";
import { BACKEND_URL } from "state/constants";


const UserImage = ({ image, size = 60 }) => {
  const [imgError, setImgError] = useState(false);
  const px = typeof size === "number" ? size : parseInt(size, 10);

  if (!image || imgError) {
    return (
      <Avatar sx={{ width: px, height: px }}>
        <Person sx={{ fontSize: px * 0.6 }} />
      </Avatar>
    );
  }

  return (
    <Box width={px} height={px}>
      <img
        style={{ objectFit: "cover", borderRadius: "50%" }}
        width={px}
        height={px}
        alt="user"
        src={BACKEND_URL + `/assets/${image}`}
        onError={() => setImgError(true)}
      />
    </Box>
  );
};

export default UserImage;
